import React, { useState, useEffect } from 'react'
import { Card, CardBody } from 'reactstrap'

import ListTopBar from '../../components/ListTopBar'

import RewardsTable from './partials/RewardsTable'
import NewRewardModal from './partials/NewRewardModal'

import { handleError } from '../../helpers'
import { getRewards } from './services'

export default function RewardsList() {
	const [rewards, setRewards] = useState(null)
	const [filterType, setFilterType] = useState('name')
	const [filterValue, setFilterValue] = useState('')
	const [filterScope, setFilterScope] = useState('active')
	const [showNewRewardModal, setShowNewRewardModal] = useState(false)

	useEffect(() => {
		!rewards && getRewards({
			[`filter[${filterType}]`]: filterValue,
			[filterScope ? `filter[${filterScope}]` : 'noscope']: 1,
			include: 'employeeRewardsCount'
		})
			.then(res => setRewards(res.data.data))
			.catch(error => handleError(error))
	}, [ rewards, filterType, filterValue, filterScope ])

	return (
		<React.Fragment>
			<ListTopBar 
				title="Catálogo de premios para empleados"
				subtitle="Premios habilitados para canjear por puntos de empleados"
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				filterScope={filterScope}
				setFilterScope={setFilterScope}
				reload={() => setRewards(null)}
				ctaText="Agregar Nuevo Premio"
				handleCtaClick={() => setShowNewRewardModal(true)}
				options={[
					{ label: 'Buscar por nombre', value: 'name' },
				]}
				scopes={[
					{ label: 'Premios activos', value: 'active' },
					{ label: 'Premios inactivos', value: 'inactive' },
				]}
			/>
			<Card>
				<CardBody>
					<RewardsTable 
						rewards={rewards}
						reload={() => setRewards(null)}
					/>
				</CardBody>
			</Card>
			{ showNewRewardModal && (
				<NewRewardModal 
					visible
					onClose={() => setShowNewRewardModal(false)}
					reload={() => setRewards(null)}
				/>
			)}
		</React.Fragment>
	)
}